import { APP_BASE_HREF } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from './app/app.config';
import { App } from './app/app';
import { AppConfig } from './app/shared/services/config.service';
import { environment } from './environments/environment';
import { LogLevel } from '@azure/msal-browser';

function normalizeBaseUrl(baseUrl: string | undefined): string {
  const value = baseUrl?.trim();

  if (!value || value === '/') {
    return '/';
  }

  return value.endsWith('/') ? value : `${value}/`;
}

const config: AppConfig = {
  production: environment.production,
  published: environment.published,
  backendUrl: environment.backendUrl,
  baseUrl: environment.baseUrl,
  appName: environment.appName,
  envName: environment.envName,
  version: environment.version,
  auth: environment.auth,
  logger: {
    logLevel: LogLevel.Warning,
    logPii: false,
  },
};

void (async () => {
  const baseUrl = normalizeBaseUrl(config.baseUrl);

  // Set the <base href> before Angular bootstraps so the router uses the correct base.
  let baseElement = document.head.querySelector<HTMLBaseElement>('base');
  if (!baseElement) {
    baseElement = document.createElement('base');
    document.head.prepend(baseElement);
  }
  baseElement.setAttribute('href', baseUrl);

  const appConfig = createAppConfig(config);

  await bootstrapApplication(App, {
    ...appConfig,
    providers: [
      ...(appConfig.providers ?? []),
      { provide: APP_BASE_HREF, useValue: baseUrl },
    ],
  });
})();
